import { useEffect } from "react";
import css from "./popUp.module.css";
import React from "react";

const PopCH = React.forwardRef(({ onClick }, ref) => {
  return (
    <div className={css.popCHWrap} ref={ref} onClick={onClick}>
      <p className={css.mainPopPLib}>
        Члени клубу — зареєстровані користувачі, підписані на email-розсилку.
        Усі члени клубу:
        <br /> - мають знижку 5% на всі замовлення;
        <br /> - мають доступ до бонусної програми (1 бонус "слон" = 1 грн),
        завдяки якій можна зменшити вартість книжок у кошику;
        <br /> - можуть брати участь у популяризації книжок: писати відгуки, за
        які на їхні рахунки надходять бонуси в кількості, відповідній обсягу
        видання;
        <br /> - можуть брати участь у опікунських радах книжок. - мають доступ
        до сторінки "Рукописи" і своїми відгуками впливають на долю розміщених
        там творів.
      </p>
    </div>
  );
});
export default PopCH;
